import { Navigate, Outlet } from 'react-router';
import { useStepPermission } from './hooks/use-step-permission';

/**
 * Cancellations layout component, with route guard for the cancellation process
 */
const CancellationLayout = () => {
	const { stepPermitted } = useStepPermission();

	// Route guard failure - this relies on the homepage doing cleanup - this currently happens via `useClearStore`
	if (!stepPermitted) {
		return <Navigate to='/' replace />;
	}

	// Route guard success
	// N.B - while there are common layout components, they have to be applied on a per page basis due to the presence of FullPageLoadingSplash
	return <Outlet />;
};

export default CancellationLayout;
